import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { LCElement, Validation } from './lc-forms.interface';
import { LCCustomValidators } from './lc-custom-validators.class';
export class LCFormService {
/**
 * @param {?} elements
 * @return {?}
 */
create(elements: LCElement[]): any {
        const /** @type {?} */ temp = {}, /** @type {?} */
            toReturn = {}, /** @type {?} */
            matches: any[] = [];

        elements.forEach(e => {
            const /** @type {?} */ val = e.value || '';
            let /** @type {?} */ validators = null;

            if (e.validation) {

                if (Array.isArray(e.validation)) {
                    validators = [];
                    e.validation.forEach(i => validators.push(setValidator(i, e)));
                } else {
                    validators = setValidator(e.validation);
                }
            }

            temp[e.key] = new FormControl(val, validators);
        });

        toReturn['fbGroup'] = new FormGroup(temp);

        // Add matches for watching if required
        if (matches.length) { toReturn['matches'] = matches; }

        return toReturn;
/**
 * @param {?} item
 * @param {?=} original
 * @return {?}
 */
function setValidator(item: Validation, original?) {
            switch (item.type) {
                case 'required': return Validators.required;
                case 'minLength': return Validators.minLength(item.value);
                case 'maxLength': return Validators.maxLength(item.value);
                case 'pattern': return Validators.pattern(item.value);
                case 'match':
                    matches.push({ toMatch: item.value, model: original.key });
                    return LCCustomValidators.match(item.value);
            }
        }
    }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function LCFormService_tsickle_Closure_declarations() {
/** @type {?} */
LCFormService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
LCFormService.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
